function getCredentials() {
  return 'Basic ' + window.btoa('stand_alone:1mSt1llStand1ng')
}

export { getCredentials }
